import { render, staticRenderFns } from "./TaskTypeConfig.vue?vue&type=template&id=34b6b19e&scoped=true"
import script from "./TaskTypeConfig.vue?vue&type=script&lang=js"
export * from "./TaskTypeConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskTypeConfig.vue?vue&type=style&index=0&id=34b6b19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6b19e",
  null
  
)

export default component.exports